// Where the return-date calendar opens (WHIT-465): on the return date once
// there is one, otherwise on the departure date, since nothing before it can
// be picked. Left to itself the calendar opened on today's month.
//
// WHIT-494: with two months side by side, a departure picked in the right-hand
// month used to reopen as the left-hand one, so every day moved one month
// under the pointer and the next click landed on the wrong date. When the
// departure calendar's first month (departureViewStart) is the month before
// the departure, the return calendar opens on that same pair of months.
const sameMonth = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();

const returnCalendarOpensAt = (fromDate, toDate, departureViewStart) => {
  if (toDate) return toDate;
  if (!fromDate) return undefined;
  if (departureViewStart) {
    const second = new Date(
      departureViewStart.getFullYear(),
      departureViewStart.getMonth() + 1,
      1,
    );
    if (sameMonth(second, fromDate)) return departureViewStart;
  }
  return fromDate;
};

// react-datepicker will not open a calendar on a month before its minDate:
// it moves the opening date forward to minDate, which undid the above. So
// when the calendar opens before the departure, minDate is the opening date
// and the days before the departure are turned off by canReturnOn instead.
const returnCalendarMinDate = (fromDate, opensAt) =>
  opensAt && fromDate && opensAt < fromDate ? opensAt : fromDate || undefined;

// A return day is any day from the departure day on.
const canReturnOn = (day, fromDate) =>
  !fromDate ||
  day >= new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());

module.exports = { returnCalendarOpensAt, returnCalendarMinDate, canReturnOn };
